import React, { useState } from 'react'
import { ModalWrapper, SelectField, StyledButton, TextFields } from '../../../../../../components'
import { Box, Chip, Typography } from '@mui/material'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { setLoader, setRefreshPage } from '../../../../../../redux/globalSlice'
import { toast } from 'react-toastify'
import { useGlobal, usePostApi } from '../../../../../../shared'
import { baseURL, urls } from '../../../../../../shared/config'
import axios from 'axios'
import { InfoField } from '../../School/PopOver/SchoolInfo'

const postSchema = Yup.object().shape({
  routeNumber: Yup.string().required('van Number is required'),
  driver: Yup.string().required('Driver is required'),
  area: Yup.string().required('Size is required'),
  // route: Yup.string().required('Route is required'),
  // attender: Yup.string().required('Attender is required'),
})
const updateSchema = Yup.object().shape({
  // routeNumber: Yup.string().required('Route Number is required'),
  // area: Yup.string().required('Size is required'),
  // route: Yup.string().required('Route is required'),
  area: Yup.string().required('Size is required'),
  routeNumber: Yup.string().required('Van number is required'),
})

export const VanForms = ({ open, handleClose, customRole, userSchoolId, update }) => {
  const validationSchema = update ? updateSchema : postSchema
  const [schoolName, setSchoolName] = React.useState('')
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })

  const { data: routeList } = useGlobal({
    userUrl: `${urls.ROUTE_GET}${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName || userSchoolId}&page=1&limit=${highestInt}`,
  })
  const { data: driverList } = useGlobal({
    userUrl: `${urls.VAN_DRIVER_GET}${customRole == 'Admin' ? userSchoolId : schoolName}&page=1&limit=10000&isAssign=false`,
  })
  // const { data: attenderList } = useGlobal({
  //   userUrl: `${urls.ATTENDER_GET}${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName}`,
  // })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name
  const data = useSelector((state) => state.global.SchoolDInfo)

  const { postApi } = usePostApi()
  const dispatch = useDispatch()
  const initialValues = {
    schoolName: '',
    routeNumber: '',
    driver: '',
    area: '',
    // route: '',
    // attender: '',
  }
  const handleSubmit = () => {
    dispatch(setLoader(true))
    validationSchema
      .validate(formik.values, { abortEarly: false })
      .then(async () => {
        const responseBody = {
          van_number: formik.values.routeNumber,
          school_id:
            customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName,
          // route_id: formik.values.route,
          employee_id: formik.values.driver,
          size: formik.values.area,
          // employee_id: formik.values.attender,
        }
        const updateBody = {
          van_id: data?.van_id,
          van_number: formik.values.routeNumber,
          // route_id: formik.values.route,
          employee_id: formik.values.driver || data?.driver_id,
          size: formik.values.area,
          // employee_id: formik.values.attender || data?.employee_id,
        }
        console.log('-----response body', updateBody)
        if (customRole != 'Admin') {
          if (!schoolName) {
            toast.error('School Name is required')
            return
          }
        }

        try {
          let response
          if (update) {
            response = await axios.patch(`${baseURL}${urls.VAN_PATCH}`, updateBody)
          } else {
            response = await postApi(urls.VAN_POST, responseBody)
          }
          console.log('====response', response)
          if (response.status === 201 || response.status === 200) {
            toast.success('Passenger Added Successfully!')
            dispatch(setRefreshPage(true))
            dispatch(setLoader(false))
            handleClose()
          } else {
            toast.error(response.message)
            dispatch(setLoader(false))
          }
        } catch (error) {
          console.error('Error occurred while submitting:', error)
          toast.error('Something Went Wrong!')
          dispatch(setLoader(false))
        }
      })
      .catch((error) => {
        if (error instanceof Yup.ValidationError) {
          error.inner.forEach((err) => {
            toast.error(err.message)
          })
        }
        dispatch(setLoader(false))
      })
  }
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  })

  React.useEffect(() => {
    if (data && update) {
      formik.setValues({
        schoolName: data?.school_name,
        routeNumber: data?.van_number,
        driver: data?.employee_name,
        // size: data?.van_size,
        area: data?.van_size,
        // route: data?.route_id,
      })
      setSchoolName(data?.school_name)
    }
  }, [data, update])

  return (
    <ModalWrapper
      open={open}
      handleClose={handleClose}
      width={'500px'}
      title={`${update ? 'Update' : 'Add'} Van`}
    >
      <div>
        {customRole == 'Admin' ? (
          <InfoField label={'School'} value={userSchoolName} width={'100%'} />
        ) : update ? (
          <InfoField label={'School'} value={schoolName} width={'100%'} />
        ) : (
          <SelectField
            required
            label={'School'}
            options={(schoolList || [])?.map((prod) => ({
              value: prod.school_id,
              label: prod.school_name,
            }))}
            width={'100%'}
            name="schoolName"
            value={schoolName}
            onChange={(selectedOption) => setSchoolName(selectedOption)}
          />
        )}
        <div className="text-fields">
          <TextFields
            label={'Van Number'}
            required
            width={'100%'}
            name={'routeNumber'}
            value={formik.values.routeNumber}
            onChange={formik.handleChange}
          />
          <SelectField
            placeholder={
              update ? `${data?.driver_first_name} ${data?.driver_last_name}` : 'Select Driver'
            }
            required
            disabled={!schoolName && !userSchoolName}
            label={'Driver'}
            options={(driverList || [])?.map((prod) => ({
              value: prod.employee_id,
              label: prod.employee_name,
            }))}
            width={'100%'}
            name={'driver'}
            value={formik.values.driver} // ID
            onChange={(selectedOption) => formik.setFieldValue('driver', selectedOption)}
          />
        </div>
        <div className="text-fields">
          <TextFields
            label={'Size'}
            required
            width={'100%'}
            name={'area'}
            value={formik.values.area}
            onChange={(e) => {
              const numericValue = e.target.value.replace(/[^0-9]/g, '')
              formik.handleChange({
                target: {
                  name: 'area',
                  value: numericValue,
                },
              })
            }}
          />
          {/* <SelectField
            placeholder={update ? `${data?.route_name}` : 'Select'}
            required
            label={'Route'}
            // disabled={!formik.values.driver }
            options={(routeList || [])?.map((prod) => ({
              value: prod.route_id,
              label: prod.route_name,
            }))}
            width={'100%'}
            name={'route'}
            value={formik.values.route}
            onChange={(selectedOption) => formik.setFieldValue('route', selectedOption)}
          /> */}
        </div>
        {/* <SelectField
          placeholder={update ? data?.employee_name : 'Select'}
          required
          disabled={!formik.values.route}
          label={'Attender'}
          options={(attenderList || []).map((prod) => ({
            value: prod.employee_id,
            label: prod.employee_name,
          }))}
          width={'100%'}
          name={'attender'}
          value={formik.values.attender}
          onChange={(selectedOption) => formik.setFieldValue('attender', selectedOption)}
        /> */}
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Box sx={{ width: '50%' }} className="in-a-row">
            <Typography className="back-btn" onClick={handleClose}>
              Cancel
            </Typography>
            <StyledButton width={'40%'} onClick={handleSubmit}>
              {update ? 'Update' : 'Add'}
            </StyledButton>
          </Box>
        </div>
      </div>
    </ModalWrapper>
  )
}

// Passenger Form
import Select, { components } from 'react-select'
import { highestInt } from '../../../../../../shared/utils/constants'

export const PassengerForm = ({ open, handleClose }) => {
  const vanID = useSelector((state) => state.global.vanID)
  const schoolID = useSelector((state) => state.global.passengerSchoolID)
  const [search, setSearch] = useState('')
  const { data: passengers } = useGlobal({
    userUrl: `${urls.STUDENT_SEARCH}${search}&school_id=${schoolID}`,
  })
  const handleInputChange = (inputValue) => {
    setSearch(inputValue)
  }

  const { postApi } = usePostApi()
  const dispatch = useDispatch()
  const [selectedPassenger, setSelectedPassenger] = React.useState(null)

  const handleSubmit = () => {
    if (!selectedPassenger) {
      toast.error('Please select a passenger')
      return
    }
    dispatch(setLoader(true))
    const passengerData = {
      van_id: vanID,
      student_id: selectedPassenger.value,
    }
    postApi(urls.PASSENGER_POAST, passengerData)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          toast.success('Passenger Added Successfully!')
          dispatch(setRefreshPage(true))
          dispatch(setLoader(false))
          handleClose()
        } else {
          toast.error(response.message)
          dispatch(setLoader(false))
        }
      })
      .catch((error) => {
        console.error('Error occurred while submitting:', error)
        toast.error('Something Went Wrong!')
        dispatch(setLoader(false))
      })
  }
  const Option = (props) => {
    return (
      <components.Option {...props}>
        <div>
          <div>{props.data.label}</div>
          <div style={{ fontSize: '0.8em', color: '#999' }}>{props.data.regNo}</div>
        </div>
      </components.Option>
    )
  }

  const passengerOptions = passengers?.map((passenger) => ({
    value: passenger.student_id,
    label: passenger.student_name,
    regNo: passenger.student_registration_number,
  }))

  const handlePassengerChange = (selectedOption) => {
    setSelectedPassenger(selectedOption)
  }
  const SingleValue = () => (
    <Chip label={selectedPassenger.label} onDelete={() => handlePassengerChange(null)} />
  )

  const customStyles = {
    valueContainer: (provided) => ({
      ...provided,
      display: 'flex',
    }),
  }

  return (
    <ModalWrapper open={open} handleClose={handleClose} width={'500px'} title={'Add Passenger'}>
      <div>
        <Select
          options={passengerOptions}
          onChange={handlePassengerChange}
          value={selectedPassenger}
          isClearable
          styles={customStyles}
          placeholder="Search for a passenger"
          components={{ SingleValue, Option }}
          onInputChange={handleInputChange}
        />

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
          <Box sx={{ width: '50%' }} className="in-a-row">
            <Typography className="back-btn" onClick={handleClose}>
              Cancel
            </Typography>
            <StyledButton onClick={handleSubmit} width={'40%'} type="submit">
              Add
            </StyledButton>
          </Box>
        </div>
      </div>
    </ModalWrapper>
  )
}
